<template>
  <div class="page">
    <div class="app-container">
     <el-form
         :model="formData"
         inline
         ref="baseForm"
         label-width="80px"
		 style="margin:5rem 5rem;"
       >
         <el-form-item class="from-item--30" label="报价公司" prop="company">
           <el-input
             type="input"
             v-model="formData.company"
             placeholder="请输入报价公司"
           ></el-input>
         </el-form-item>
		 <br>
		 <el-form-item class="from-item--30" label="logo" prop="company_logo">
		   <el-upload
		     class="avatar-uploader"
		     :action="$settings.uploadUrl.img + '/admin/upload/upimg'"
		     name="img"
		     :show-file-list="false"
		     :headers="{
		       token: getToken(),
		     }"
		     :data="{
		       path: 20,
		     }"
		     :on-success="(res) => uploadImgSuccess(res,'company_logo')"
		   >
		     <img
		       v-if="formData.company_logo"
		       :src="formData.company_logo"
		       class="avatar"
		     />
		     <i v-else class="el-icon-plus avatar-uploader-icon"></i>
		   </el-upload>
		 </el-form-item>
		 <br>
		 <el-form-item class="from-item--30" label="水印" prop="company_watermark">
		   <el-upload
		     class="avatar-uploader"
		     :action="$settings.uploadUrl.img + '/admin/upload/upimg'"
		     name="img"
		     :show-file-list="false"
		     :headers="{
		       token: getToken(),
		     }"
		     :data="{
		       path: 20,
		     }"
		     :on-success="(res) => uploadImgSuccess(res,'company_watermark')"
		   >
		     <img
		       v-if="formData.company_watermark"
		       :src="formData.company_watermark"
		       class="avatar"
		     />
		     <i v-else class="el-icon-plus avatar-uploader-icon"></i>
		   </el-upload>
		 </el-form-item>
		 <br>
		 <el-form-item class="from-item--30" label="公章" prop="official_seal">
		   <el-upload
		     class="avatar-uploader"
		     :action="$settings.uploadUrl.img + '/admin/upload/upimg'"
		     name="img"
		     :show-file-list="false"
		     :headers="{
		       token: getToken(),
		     }"
		     :data="{
		       path: 20,
		     }"
		     :on-success="(res) => uploadImgSuccess(res,'official_seal')"
		   >
		     <img
		       v-if="formData.official_seal"
		       :src="formData.official_seal"
		       class="avatar"
		     />
		     <i v-else class="el-icon-plus avatar-uploader-icon"></i>
		   </el-upload>
		 </el-form-item>
	
		 <div class="confirm">
		   <el-button type="primary" @click="submit">提交</el-button>
		   <el-button type="info" @click="resetInfo">重置</el-button>
		 </div>
       </el-form>
    </div>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
export default {
  name: "quotation",
  comments: {},
  data() {
    return {
      formData: {
		  company: '',
		  company_logo: '',
		  company_watermark: '',
		  official_seal: ''
	  },
    };
  },
  computed: {
	  
  },
  created() {
	  this.getDetail();
  },
  methods: {
	getToken,
	// 获取详情
	getDetail(){
		this.$api.post("/admin/org/getQuotation", {}).then((res) => {
			if(res.data){
				this.formData = {...res.data};
			}
		});
	},
	// 上传图片成功后
	uploadImgSuccess(res,key) {
		console.log(key)
		console.log(res)
	  if(key == 'company_logo'){
		   this.formData.company_logo = res.data.path;
	  }
	 if(key == 'official_seal'){
	 	   this.formData.official_seal = res.data.path;
	 }
	 if(key == 'company_watermark'){
		 this.formData.company_watermark = res.data.path;
	 }
	},
    // 图片上传之前
    beforeUpload(file) {
      
    },
	// 提交表单
	submit() {
	    const data = this.formData;
	    this.$api.post('/admin/org/setQuotation', { 
		  'company': data.company,
		  'company_logo': data.company_logo,
		  'company_watermark' : data.company_watermark,
		  'official_seal': data.official_seal
	    }, '报价单设置');
		
	},
	// 重置表单
	async resetInfo() {
	  const res = await this.$confirm("重置将会清空您填的数据，是否确认？");
	  if (res !== "confirm") return;
	  this.formData = {
		  company: '',
		  company_logo: '',
		  company_watermark: '',
		  official_seal:''
	  };
	}
  },
};
</script>
<style>
	.avatar-uploader .el-upload {
	  border: 1px dashed #d9d9d9;
	  border-radius: 6px;
	  cursor: pointer;
	  position: relative;
	  overflow: hidden;
	}
	.avatar-uploader .el-upload:hover {
	  border-color: #409eff;
	}
	.avatar-uploader-icon {
	  font-size: 28px;
	  color: #8c939d;
	  width: 150px;
	  height: 150px;
	  line-height: 150px;
	  text-align: center;
	}
	.avatar {
	  width: 150px;
	  height: 150px;
	  display: block;
	}
	.confirm {
	  margin-top: 20px;
	  margin-left: 70px;

	}
</style>